import { useIntl } from 'react-intl';
import { TranslationKey, TranslationsFunc } from '../types';

const getDefaultMessage = (id: TranslationKey) => `**NO-TEXT-FOUND-FOR: ${id}**`;

export const useTranslations = () => {
  const { formatMessage, ...rest } = useIntl();
  const t: TranslationsFunc = (id, values, options) =>
    formatMessage({ id, defaultMessage: getDefaultMessage(id) }, values, options);

  return {
    ...rest,
    t,
  };
};
